import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { EmployeeResponse } from '../../../types/Employee';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export type EmployeeAvailableColumns = 'display_name' | 'roles' | 'title_value' | 'email' | 'phone' | 'invite' | 'tags';

export type EmployeeFilterParam = {
  uuid?: string[];
  event?: string;
  employee_role?: string[];
};

export type EmployeeSortableColumns = Exclude<EmployeeAvailableColumns, 'invite'>;

export type EmployeeSortParam = {
  [K in EmployeeSortableColumns]?: -1 | 1;
};

export type UseGetAllEmployeesParams = {
  page?: number;
  per_page?: number;
  search?: string;
  filters?: EmployeeFilterParam;
  sort?: EmployeeSortParam;
  list_columns?: EmployeeAvailableColumns[];
};

export type UseGetAllEmployeesProps = {
  params?: UseGetAllEmployeesParams;
  enabled?: boolean;
};

export const fetchAllEmployees = async ({ params }: UseGetAllEmployeesProps) => {
  const response = await CustomAxios.get<EmployeeResponse>(`employees`, { params });
  const { data } = response;
  return data;
};

export function useGetAllEmployees({ params, enabled = true }: UseGetAllEmployeesProps) {
  const queryKey: any = [queryKeys.allEmployees, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllEmployees({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
